exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---LdIvj .option-container---1nCS6 {\n  display: inline-block;\n  margin: auto;\n  text-align: left; }\n\n.component---LdIvj .option---3FPQV {\n  margin: 16px 0; }\n\n.component---LdIvj .option---3FPQV label {\n    margin-left: 24px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---LdIvj",
	"option-container": "option-container---1nCS6",
	"option": "option---3FPQV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/improvement-type-picker/improvement-type-picker.scss
// module id = dRRz
// module chunks = 1